import { invertResult } from "@kikoff/utils/src/function";

import { RootState } from "@store";
import { accountAutoPayEnabled } from "@util/payments";

import { selectCreditAccountOverdue } from "./credit_line";
import { selectCbsLoan } from "./loans";
import { selectDismissable, selectFeatureFlag } from "./page";

export const selectShowScheduleAutopayPrompt = (product: "CA" | "CBL") => (
  state: RootState
) =>
  selectDismissable(`SCHEDULE_${product}_AUTOPAY_PROMPT`)(state) &&
  accountAutoPayEnabled(
    { CA: () => state.creditLine.account, CBL: selectCbsLoan() }[product](state)
  ) &&
  selectAllowScheduleAutopay(product)(state);

export const selectAllowScheduleAutopay = (product: "CA" | "CBL") => (
  state: RootState
) =>
  selectFeatureFlag("schedule_auto_pay")(state) &&
  { CA: invertResult(selectCreditAccountOverdue()), CBL: () => false }[product](
    state
  );
